import styled, { css } from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import {
  blueMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
} from "@ryde/theme";

export const ReportGridWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-grid-wrapper",
})`
  min-width: 100%;
  padding-inline-start: 0;
  padding-inline-end: 4px;
  padding-bottom: 10px;
  margin-top: 10px;
  position: relative;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 0;
  }
`;

export const TableTagReportStyled = styled.table.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "table-root-report",
})<{ $isSized?: boolean }>`
  padding-bottom: 5px;
  table-layout: fixed;
  white-space: nowrap;
  overflow-x: auto;
  border: 0;
  border-collapse: separate;
  border-spacing: 0;
  padding-inline-end: 10px;
  width: auto;
  min-width: 100%;
  thead {
    padding: 2px;
  }
  thead tr:first-child th:first-child {
    border-start-start-radius: 3px;
  }

  thead tr:first-child th:last-child {
    border-start-end-radius: 3px;
    border-inline-end: 1px solid ${greyMui._300};
  }

  thead tr:first-child th:first-child {
    border-start-end-radius: 3px;
    border-inline-start: 2px solid ${blueMui._300};
  }

  tfoot tr th:first-child {
    border-inline-start: 2px solid ${blueMui._300};
  }

  tfoot tr:nth-child(2) th:first-child {
    border-end-start-radius: 3px;
  }

  tfoot tr:nth-child(2) th:last-child {
    border-end-end-radius: 3px;
  }

  tfoot tr th:last-child {
    border-inline-end: 1px solid ${greyMui._300};
  }

  tfoot tr:last-child th {
    border-bottom: 1px solid ${greyMui._300};
  }

  tbody tr td:last-child {
    border-inline-end: 1px solid ${greyMui._300};
  }
  tbody tr td:first-child {
    border-inline-start: 2px solid ${blueMui._300};
  }
  tbody tr:last-child td {
    border-bottom: 1px solid ${greyMui._300};
  }
  tr th {
    background-color: ${rydeColors.white};
    height: 37px;
  }
  tr td {
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 37px;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  tr:nth-child(odd) td {
    background-color: ${rydeColors.white};
  }

  tr:nth-child(even) td {
    background-color: ${rydeColors.rowHighlight};
  }

  tr td:not(.details_panel) {
    overflow: hidden;
  }

  tbody tr:hover td {
    background-color: ${deepPurpleMui._50};
  }

  tbody tr td:first-child {
    padding-inline-start: 10px;
    background-repeat: repeat-y;
  }

  thead tr th:first-child {
    padding-inline-start: 10px;
    background-repeat: repeat-y;
  }

  tfoot tr th:first-child {
    padding-inline-start: 10px;
    background-repeat: repeat-y;
  }

  tfoot tr th {
    background-color: ${rydeColors.white};
  }

  tr th.col_idempty {
    border-top: none;
    border-bottom: none;
    padding: 0;
    margin: 0;
    width: 2px;
  }

  .divider-footer-row th {
    height: 10px;
    background-color: ${greyMui._100};
    font-size: 11px;
    font-weight: 400;
    text-align: left;
    margin-inline-start: 10px;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: auto;
    min-width: 100%;
  }

  /* Once a column is resized the widths are exact: a fixed-layout table is never narrower than its columns,
     so 1px renders their sum instead of growing them to the content or the screen. Kept after the media
     query so it wins there too. */
  & {
    ${({ $isSized }) =>
      $isSized &&
      css`
        width: 1px;
        min-width: 0;
      `}
  }
`;
